// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"780":"75c80767","828":"e143f0d8"}[chunkId] + ".chunk.js";
};